export enum TasksListType {
  TASK_LIST = 'task-list',
  KANBAN = 'kanban',
  DASHBOARD = 'dashboard',
}
